import PropTypes from 'prop-types';
import { LabelItem, Tooltip, InfoIcon } from '@spotahome/ui-library';

import { trans } from '@spotahome/soyuz/client';

import './BookNowPermanentContractLabel.scss';

const BookNowPermanentContractLabel = ({
  allowsPermanentContract = false,
  allowsTemporalContract = true,
  countryCode
}) => {
  return !allowsPermanentContract ? null : (
    <div className="booknow-card-label">
      <LabelItem
        className="booknow-card-label__label"
        text={trans('homecard.label.long-term')}
        color="blue-indigo"
      />
      <span className="booknow-card-label__text">
        {allowsTemporalContract
          ? trans('search.booknow-card-label.text')
          : trans('search.booknow-card-label.text-permanent')}
      </span>
      {countryCode && (
        <Tooltip
          className="booknow-card-label__tooltip"
          color="blue-cerulean"
          tooltip={trans(
            `search.booknow-card-label.tooltip.permanent.${countryCode.toLowerCase()}`
          )}
          position="left"
        >
          <InfoIcon size={20} />
        </Tooltip>
      )}
    </div>
  );
};
BookNowPermanentContractLabel.propTypes = {
  allowsPermanentContract: PropTypes.bool,
  allowsTemporalContract: PropTypes.bool,
  countryCode: PropTypes.string.isRequired
};

export default BookNowPermanentContractLabel;
